import { Breakpoint } from '@philips-emr/tws-constants';
import { getBreakpoint } from '@philips-emr/tws-utils';

const NOT_RENDERED_COMPONENT_APIS = 'You should not access not rendered component apis.';

function catchRenderException(arg: () => void, defaultValue?: any): any {
  try {
    return arg();
  } catch (e) {
    if (e instanceof Error) {
      const ignoreErr = [NOT_RENDERED_COMPONENT_APIS];
      if (!ignoreErr.includes(e.message)) {
        console.error(e);
      }
    }
    return defaultValue;
  }
}

function shouldRenderMobile(): boolean {
  const breakpoint = getBreakpoint();
  return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
}

export {
  catchRenderException,
  shouldRenderMobile,
};
